import { tv } from '~/utils/tv'

const inputPasswordStyles = tv({
  slots: {
    root: ['w-full min-w-[14rem] space-y-[var(--spacing-stack-halfpulse)]'],
    control: [
      // Structure
      'ring-[var(--color-forms-border-default)]',
      'inline-flex w-full items-center',
      'gap-x-[var(--spacing-inline-onepulse)]',
      'rounded-[var(--border-radius-form)]',
      'bg-[var(--color-forms-fill-default)]',
      'px-[var(--padding-inset-threepulse)]',

      // Filled state
      '[&:has(input:not(:focus-within,:placeholder-shown))]:bg-[var(--color-forms-fill-filled)]',
      '[&:has(input:not(:focus-within,:placeholder-shown))]:ring-[length:var(--border-width-quarterpulse)]',
    ],
    input: [
      'min-w-0 flex-1 bg-transparent caret-[var(--color-text-neutral-default)] outline-0',
      'placeholder:invisible',
      'font-sans text-[var(--color-text-neutral-default)]',
    ],
  },
  variants: {
    size: {
      md: {
        control: ['h-[var(--sizing-medium)]'],
        input: ['text-[length:var(--font-size-threepulse)]'],
      },
      ml: {
        control: ['h-[var(--sizing-mediumlarge)]'],
      },
      lg: {
        control: ['h-[var(--sizing-large)]'],
      },
      xl: {
        control: [
          'h-[var(--sizing-extralarge)] rounded-[var(--border-radius-largecontainer)]',
        ],
      },
    },
    isDisabled: {
      true: {
        control: [
          'cursor-not-allowed bg-[var(--color-forms-fill-disabled)]! ring-[length:var(--border-width-quarterpulse)] ring-[var(--color-forms-border-disabled)]',
          '*:cursor-not-allowed',

          // Filled state
          '[&:has(input:not(:focus-within,:placeholder-shown))]:bg-[var(--color-forms-fill-disabled)]',
        ],
        input: ['text-[var(--color-text-neutral-disabled)]'],
      },
    },
    isReadOnly: {
      true: {
        control: [
          'pointer-events-none bg-[var(--color-forms-fill-readonly)] ring-[length:var(--border-width-quarterpulse)] ring-[var(--color-forms-border-readonly)]',

          // Filled state
          '[&:has(input:not(:focus-within,:placeholder-shown))]:bg-[var(--color-forms-fill-readonly)]',
        ],
        input: ['text-[var(--color-text-neutral-readonly)]'],
      },
    },
    isError: {
      true: {
        control: [
          // Error ring
          'ring-[length:var(--border-width-quarterpulse)]',
          'ring-[var(--color-forms-border-error)]',

          // Hover when error
          '[&:not(:focus-within,[data-disabled])]:hover:ring-[length:var(--border-width-halfpulse)]',

          // Focus when error
          'focus-within:bg-[var(--color-forms-fill-error)]',
          'focus-within:ring-[length:var(--border-width-halfpulse)]',
        ],
      },
      false: {
        control: [
          // Focus when not error
          'focus-within:bg-[var(--color-forms-fill-focused)]',
          'focus-within:ring-[length:var(--border-width-halfpulse)]',
          'focus-within:ring-[var(--color-forms-border-focused)]',

          // Filled ring color
          '[&:has(input:not(:focus-within,:placeholder-shown))]:ring-[var(--color-forms-border-filled)]',
        ],
      },
    },
  },
  compoundVariants: [
    {
      size: ['ml', 'lg', 'xl'],
      class: {
        input: ['text-[length:var(--font-size-threeandhalfpulse)]'],
      },
    },
    {
      isDisabled: false,
      isReadOnly: false,
      isError: false,
      class: {
        control: [
          // Hover
          '[&:not(:focus-within)]:hover:bg-[var(--color-forms-fill-hovered)] [&:not(:focus-within)]:hover:ring-[var(--color-forms-border-hovered)]',

          // Filled hover
          '[&:has(input:not(:focus-within,:placeholder-shown))]:hover:bg-[var(--color-forms-fill-filled)] [&:has(input:not(:focus-within,:placeholder-shown))]:hover:ring-[var(--color-forms-border-filled)]',
          '[&:has(input:not(:focus-within,:placeholder-shown))]:hover:ring-[length:var(--border-width-halfpulse)]',
        ],
      },
    },
  ],
  defaultVariants: {
    size: 'ml',
    isDisabled: false,
    isReadOnly: false,
    isError: false,
  },
})

export const { root, control, input } = inputPasswordStyles()
